import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { Icon } from '../../../icon/icon';
import { ContentList } from './card';

type Props = {
  selected: boolean;
};

const TerrainModelContent = (_props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Component>
      <ContentList>
        <li>
          <Icon
            color={theme.color.blue}
            fixedWidth={true}
            icon={['fal', 'circle-info']}
            style={{ marginTop: '0.2em' }}
          />
          <span>{t('setupDialog.addOns.terrainModel.info', { ns: 'cloudProcessing' })}</span>
        </li>

        <li>
          <Icon
            color={theme.color.green}
            fixedWidth={true}
            icon={['fal', 'check']}
            style={{ marginTop: '0.2em' }}
          />
          <span>
            {t('setupDialog.addOns.terrainModel.terrainModelDxf', { ns: 'cloudProcessing' })}
          </span>
        </li>

        <li>
          <Icon
            color={theme.color.green}
            fixedWidth={true}
            icon={['fal', 'check']}
            style={{ marginTop: '0.2em' }}
          />
          <span>
            {t('setupDialog.addOns.terrainModel.viewAndCalculateVolumes', {
              ns: 'cloudProcessing',
            })}
          </span>
        </li>

        <li>
          <Icon
            color={theme.color.green}
            fixedWidth={true}
            icon={['fal', 'check']}
            style={{ marginTop: '0.2em' }}
          />
          <span>{t('setupDialog.items.dataExport', { ns: 'cloudProcessing' })}</span>
        </li>
      </ContentList>
    </Component>
  );
};

const Component = styled.section``;

export { TerrainModelContent };
